import axios from "axios";

const getBinding = (header) => axios.get(`/personal/api/v1/mobile-2fa/binding/current`, {
    headers: { ["X-Query"]: JSON.stringify(header), },
    responseType: 'json',
  });


  export default {
    getBinding
  }